import * as yup from 'yup'

const createSchema = function () {
  return yup.object({
    /**
     * Стандартный обязательный параметр для Битрикс форм.
     * Можете передаваться как hidden поле. Можно указать сразу в схеме,
     * в форме или поле. Как угодно. Но использование с схеме
     * упростит отладку и тестирование.
     */
    WEB_FORM_ID: yup
      .string()
      .trim()
      .default('6')
      .required('${label} надо указать ID формы'),
    /**
     * В битрикс поля форм имеют согласованные именования. Они уникальны
     * в рамках одного экземпляра Битрикс, одной установки. Цифры в именах
     * вообще ничего не значат, это просто суффикс для сохранения уникальности
     * имени. Все поля передаются в $_POST массиве, компонент просто напросто
     * "забирает" поля связанные с идентификатором формы. То сеть поля можно
     * отправить на сервер любым способом. Все предельно стандартно.
     *
     * @see https://dev.1c-bitrix.ru/api_help/form/htmlnames.php
     */
    form_text_50: yup
      .string()
      .trim()
      .default('')
      .required('${label} должно быть заполнено.')
      .label('Ф.И.О'),
    form_text_52: yup
      .string()
      .default('')
      .required('${label} должен быть заполнен.')
      .test(
        'mobile-phone',
        'Требуется указать мобильный номер российского оператора.',
        (value) => {
          /**
           * Перед проверкой формата удалить пробелы
           * и дефисы. Таким образом логика упрощается, а смысл остается.
           */
          const _value = String(value).replace(/[\s-]*/g, '')
          /**
           * строка начинается с группы, в которой могут быть
           * (+7|+8|7|8) или вообще отсутствовать символы. Необязательным
           * считается вся группа или символ `+` внутри группы. Затем
           * обязательно цифра 9 и за ней девять любых цифр. Например, 9000000000.
           * То есть обязательная часть это десять цифр начинающихся с девятки.
           */
          return /^(\+?7|8)?9\d{9}$/.test(_value)
        }
      )
      .label('Телефон'),
    form_email_51: yup
      .string()
      .default('')
      .trim()
      .email('Введите корректный адрес электронной почты')
      .required('Email обязателен')
      .label('Email'),
    form_textarea_53: yup
      .string()
      .default('')
      .trim()
      .max(500, 'Не более 500 символов')
      .label('Сообщение'),
    form_hidden_55: yup
      .string()
      .default('Да'),
    agreement: yup
      .boolean()
      .default(true)
      .required('Необходимо отметить согласие')
      .label('Согласие с условиями'),
    })
}

export {
  createSchema
}
